var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"print-model"},[(!_setup.loading)?_c('div',{ref:"printMe",attrs:{"id":"printMe"}},[_c(_setup.PointOfSale,{attrs:{"item":_vm.item}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }